export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SearchForm.vue?vue&type=template&id=c4c8703e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/components/SearchForm/SearchForm.vue?vue&type=template&id=c4c8703e&scoped=true&
// module id = 32
// module chunks = 0